import "./quizItems.css"
import components from '../../../assets/data/components.json'
import { useState } from "react";

interface IActiveQuiz {
    name: string;
    numberofQuiz: number;
    buttonText: string;
    onClick: any;
    height?: string;
    width?: string;
}
interface IHistoryQuiz {
    name: string;
    numberofQuiz: number;
    per:number;
    onClick: any;
    height?: string,
    width?: string
}
interface IQuizChoice {
    text: string,
    image?: string,
    variant: number,
    onClick: any,
    active?: Boolean,
    height?: string,
    width?: string
}

interface IQuizHeading {
    totalQuestion: number,
    currentQuestion: number,
    coin: number,
    progressType:string,
    height?: string,
    width?: string
}

interface IQuizInputBox {
    placeHolder: string,
    onChange: any,
    height?: string,
    width?: string
}
interface IQuizInfo {
    text: string
    q_image: string
    height?: string,
    width?: string
}

interface IQuizCompletionCard {
    height?: string,
    width?: string
    text: string,
    head:string
}

export function ActiveQuizCard(props: IActiveQuiz) {
    return (
        <div className="activeQuizCard d-flex"
            style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }} onClick={props.onClick}>
            <div className="quiztextWrapper">
                <div className="activeQuizName">{props.name}</div>
                <div className="quizQuestionCount">{props.numberofQuiz + " questions"}</div>
            </div>
            <button>{props.buttonText}</button>
        </div>)
}

export function HistoryQuizCard(props: IHistoryQuiz) {
    return (
        <div className="historyQuizCard d-flex align-items-center"
            style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }} onClick={props.onClick}>
            <img className="pencilImage" src={components.baseURL + "quiz-pencil.svg"}></img>
            <div className="quiztextWrapper">
                <div className="historyQuizName">{props.name}</div>
                <div className="quizQuestionCount">{props.numberofQuiz + " questions"}</div>
            </div>
                <progress className={`progressL${props.per<40?1:props.per<80?2:3}`} max={100} value={props.per}></progress>
            <img className="arrowImage" src={components.baseURL + "arrow-icon.svg"}></img>
        </div>)
}

export function QuizHeading(props: IQuizHeading) {
    return (<div className='quizHeading d-flex align-items-center justify-content-between'
        style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }}>
        <span>{"Question " + props.currentQuestion + " of " + props.totalQuestion}</span>
        <progress className={`progressV${props.progressType}`} max={props.totalQuestion} value={props.currentQuestion}></progress>
        <span>{props.coin + " coin"+(props.coin>1?'s':'')}</span>
    </div>)
}

export function QuizQuestion(props: IQuizInfo) {
    //console.log(props.q_image);
    return (<div className='quizQuestion d-flex flex-column align-items-center justify-content-start justify-content-md-center'
        style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }}>
        <span dangerouslySetInnerHTML={{ __html: props.text }}></span>
        {(props.q_image) && (
            <img id="q_image" style={{ maxHeight: "70%", maxWidth: '90%' }} src={props.q_image}></img>
        )}
    </div>)
}

export function QuizExplanation(props: IQuizInfo) {
    //console.log(props.q_image);
    const [show, setShow] = useState(false);
    return (<>
        <button className="showExplanation" onClick={() => { setShow(true) }}>Show explanation</button>
        {(show) && (
            <div className='quizExplanation d-flex flex-column align-items-start justify-content-start'
            onTouchMove={() => { setShow(false) }} onDrag={() => { setShow(false) }}
                style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }}>
                <button id="downBtn" onTouchStart={() => { setShow(false) }} onDrag={() => { setShow(false) }} onClick={() => { setShow(false) }}><img src={components.baseURL + 'down-btn.svg'}></img></button>
                {(props.q_image) && (
                    <img id="q_image" style={{ maxHeight: "70%", maxWidth: '90%' }} src={props.q_image}></img>
                )}
                <span className="expDescription">Description</span>
                <span dangerouslySetInnerHTML={{ __html: props.text }}></span>
            </div>
        )}
    </>)
}

export function QuizInputBox(props: IQuizInputBox) {
    return (<input className="quizInputBox" placeholder={props.placeHolder} ></input>)
}

export function QuizButton(props: IQuizChoice) {
    return (<>
        {(!props.image) && (
            <button className={'quizChoice hoverPointer quizChoice-' + (props.active ? 'active' : 'v' + props.variant)}
                style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }} onClick={props.onClick}
                dangerouslySetInnerHTML={{ __html: props.text }}>
            </button>)}
        {(props.image) && (
            <button className={'quizChoice hoverPointer quizChoice-' + (props.active ? 'active' : 'v' + props.variant)}
                style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }} onClick={props.onClick}>
                <img src={props.image} style={{ maxHeight: "98%", maxWidth: "95%" }}></img>
            </button>)}
    </>)
}

export function QuizReadOnlyButton(props: IQuizChoice) {
    return (<>
        {(!props.image) && (
            <div className={'d-flex align-items-center justify-content-center quizChoice quizChoice-' + (props.active ? 'active' : 'v' + props.variant)}
                style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }}
                dangerouslySetInnerHTML={{ __html: props.text }}>
            </div>)}
        {(props.image) && (
            <div className={'d-flex align-items-center justify-content-center quizChoice quizChoice-' + (props.active ? 'active' : 'v' + props.variant)}
                style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }} >
                <img src={props.image} style={{
                    maxHeight: "90%", maxWidth: "95%",
                    border: props.variant == 2 ? '3px solid var(--secondary-green)' :
                        props.variant == 3 ? '3px solid var(--secondary-red)' : ''
                }}></img>
            </div>)}
    </>)
}

export function QuizCompletionCard(props: IQuizCompletionCard) {
    return (<div className='quizCompletionCard'
        style={{ height: props.height ? props.height : '', width: props.width ? props.width : '' }}>
        <img id="vector_741_1" src={components.baseURL + 'vector-741.svg'}></img>
        <img id="vector_1021_2" src={components.baseURL + 'vector-1021.svg'}></img>
        <img id="union_100_3" src={components.baseURL + 'union.svg'}></img>
        <img id="ellipse_107_4" src={components.baseURL + 'ellipse-107.svg'}></img>
        <img id="ellipse_109_5" src={components.baseURL + 'ellipse-109.svg'}></img>
        <img id="vector_100_6" src={components.baseURL + 'vector-100.svg'}></img>
        <img id="vector_1061_7" src={components.baseURL + 'vector-1061.svg'}></img>
        <img id="vector_741_8" src={components.baseURL + 'vector-741.svg'}></img>
        <img id="vector_741_9" src={components.baseURL + 'vector-741.svg'}></img>
        <img id="vector_741_10" src={components.baseURL + 'vector-741.svg'}></img>
        <img id="vector_741_11" src={components.baseURL + 'vector-741.svg'}></img>
        <img id="vector_1021_12" src={components.baseURL + 'vector-1021.svg'}></img>
        <img id="vector_1021_13" src={components.baseURL + 'vector-1021.svg'}></img>
        <span>{props.head}</span>
        <span className="message">{props.text}</span>
    </div>)
}